'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const ErrorPageBox = styled(Box)(() => ({
    display: "flex",
    alignItems: "left",
    justifyContent: "left",
    flexDirection: "column",
    gap: 2,
}));

export default ErrorPageBox;
